import type { Metadata } from "@/lib/head";

import ToolIntro from "@/pages/tools/_ui/tool-intro";
import NoticeTool from "@/pages/tools/notice/notice-tool";

export const metadata: Metadata = {
  title: "인테리어 공사 안내문 만들기 (QR 포함) — 무료 인쇄",
  description:
    "엘리베이터·게시판에 붙이는 인테리어 공사 안내문을 A4 한 장으로 만듭니다. 단지·동호, 공사 기간, 작업 시간, 시공사 연락처와 상담 QR 까지 — 로그인 없이 바로 인쇄.",
};

// 공사 안내문 — 칸은 이 화면에서만 고치고 저장하지 않는다.
const NoticeToolPage = () => (
  <div className="flex flex-col gap-4">
    <ToolIntro
      description="칸을 채우면 아래 종이가 바로 바뀝니다. 입력한 내용은 어디에도 저장되지 않습니다."
      title="공사 안내문 만들기"
    />
    <NoticeTool />
  </div>
);

export default NoticeToolPage;
